import React, { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import ListPage from '../../sharedModules/listPage/ListPage';
import { formatDate } from '../../utils/formatDate';
import StepResultsList from './StepResultsList';
import StepSummaryChip from './StepSummaryChip';

const formatStatus = (s: string) => s?.split('_').join(' ');

const StepResultsRow: FC<{ data?: any }> = ({ data = {} }) => {
  const steps = data.step_results_titleized ?? {};

  return (
    <Box sx={{ px: 4, py: 2, backgroundColor: '#fafafa', borderBottom: '1px solid #e0e0e0' }}>
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        Step Results
      </Typography>
      <Divider sx={{ mb: 1.5 }} />
      <StepResultsList steps={steps} />
    </Box>
  );
};

const CallbackResultsPage: FC = () => {
  const defaultFilters = {
    record_type_eq: 'BackflowJobGroup',
    new_status_eq: 'approved',
  };

  const clearFilterSetting = {};

  const callbackColumns = [
    {
      name: 'Order No',
      selector: 'record_identifier',
      grow: 1,
    },
    {
      name: 'Result',
      selector: 'success',
      width: '140px',
      cell: (row: any) => <StepSummaryChip success={row.success} />,
    },
    {
      name: 'Status Transition',
      selector: 'old_status',
      grow: 1.2,
      cell: (row: any) => (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="caption">{formatStatus(row.old_status)}</Typography>
          <Typography variant="caption" color="text.secondary">
            →
          </Typography>
          <Typography variant="caption">{formatStatus(row.new_status)}</Typography>
        </Box>
      ),
    },
    {
      name: 'Failed Step',
      selector: 'failed_step',
      grow: 1.5,
      cell: (row: any) =>
        row.failed_step ? (
          <Typography variant="caption" color="error">
            {formatStatus(row.failed_step)}
          </Typography>
        ) : null,
    },
    {
      name: 'Ran At',
      selector: 'created_at',
      grow: 0.8,
      cell: (row: any) => formatDate(row.created_at),
    },
  ];

  return (
    <ListPage
      title="Callback Results"
      titleIcon={<CallIcon />}
      controller="/status_callback_audits"
      columns={callbackColumns}
      defaultFilters={defaultFilters}
      defaultSort="created_at desc"
      clearedFilterSetting={clearFilterSetting}
      expandableRowsComponent={<StepResultsRow />}
    />
  );
};

export default CallbackResultsPage;
